/**
 * Aiká — Header
 * Controla: drawer mobile (menu lateral), toggle da barra de busca,
 * e o header que some ao rolar pra baixo / volta ao rolar pra cima.
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-header]').forEach((header) => {
    const drawer = document.querySelector('[data-header-drawer]');
    const openBtn = header.querySelector('[data-header-drawer-open]');
    const closeBtns = drawer ? drawer.querySelectorAll('[data-header-drawer-close]') : [];

    if (openBtn && drawer) {
      openBtn.addEventListener('click', () => {
        drawer.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
      });
    }

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        drawer.classList.add('hidden');
        document.body.style.overflow = '';
      });
    });

    const searchBtn = header.querySelector('[data-header-search-open]');
    const searchBar = header.querySelector('[data-header-search-bar]');
    if (searchBtn && searchBar) {
      searchBtn.addEventListener('click', () => {
        searchBar.classList.toggle('hidden');
        if (!searchBar.classList.contains('hidden')) {
          const input = searchBar.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      });
    }

    if (header.dataset.hideOnScroll !== 'false') {
      let lastScroll = window.scrollY;

      window.addEventListener(
        'scroll',
        () => {
          const current = window.scrollY;
          if (current > lastScroll && current > 120) {
            header.style.transform = 'translateY(-100%)';
          } else {
            header.style.transform = 'translateY(0)';
          }
          lastScroll = current;
        },
        { passive: true }
      );
    }
  });
});
